import React from "react";

const SelectorAccordionGroup = props => {
  const { children, name, open, handleOnClick, height, extraPadding } = props;
  let contentClasses = "selector-according-group-content";
  if (open) contentClasses += " open";
  return (
    <div className="selector-accordion-group">
      <div
        className="selector-accordion-group-title"
        onClick={() => handleOnClick()}
      >
        <div className="selector-accordion-group-title-text" style={{ paddingLeft: extraPadding ? "10px" : 0}}>{name}</div>
        <div className="selector-accordion-group-title-name">{open ? "▼" : "◀"}</div>
      </div>
      <div
        className={contentClasses}
        style={{ paddingLeft: extraPadding ? "10px" : 0 }}
      >
        {children}
      </div>
    </div>
  );
};

export default SelectorAccordionGroup;
